import { rootApi } from "../../api/rootApi";

export const batchApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchSalesUser: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/siyaram/sales-list`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),

        fetchEmpSalesUser: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/siyaram/emp-by-sales`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
    }),
});

export const {
    useFetchSalesUserMutation,
    useFetchEmpSalesUserMutation,
} = batchApi;
